import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Subject, throwError } from "rxjs";
import { GAMESTATUS, GAMETYPES, MINAGES } from "../../constants/constants";
import { GameDetails, GameModalMessage, GamePoints, MyPrize, OptInRequestModel, PrizeDetail, Prizes, ProfileType, SweepstakesWinner } from '../../constants/divisional.interface';
import { programPoints } from '../../mocks/mockProgramPoints';
import {environment} from '../../../../environments/environment';
import {ParamService} from "../param.service";
import {v4 as uuidv4} from 'uuid';
function _window(): any {
    return window;
}

// Changing to false as per https://jira.safeway.com/browse/GC-2679 
const xAPIOcrpRewardsHttpOptionsV2 = true;

// https://jira.safeway.com/browse/ACIP-232489
const userTypeParamFlag = true;

@Injectable({
    providedIn: 'root'
})
export class GameService {
    banner = this.paramService.banner;
    public refreshGameDetails = new Subject<GameDetails>();
    public refreshGameDetailsObservable = this.refreshGameDetails.asObservable();

    public refreshGamePoints = new Subject<boolean>();
    public refreshGamePointsObservable = this.refreshGamePoints.asObservable();

    public refreshOptInStatus = new Subject<boolean>();
    public refreshOptInStatusObservable = this.refreshOptInStatus.asObservable();

    public refreshOptInStatusOnly = new Subject<any>();
    public refreshOptInStatusOnlyObservable = this.refreshOptInStatusOnly.asObservable();

    public gameModalMessage = new Subject<GameModalMessage>();
    public gameModalMessageObservable = this.gameModalMessage.asObservable();

    public gamePointsUpdated = new Subject<GamePoints>();
    public gamePointsUpdatedObservable = this.gamePointsUpdated.asObservable();

    public prizeRedeemed = new Subject<any>();
    public prizeRedeemedObservable = this.prizeRedeemed.asObservable();

    public manageGamesInfo = new Subject<any>();
    public manageGamesInfoObserable = this.manageGamesInfo.asObservable();
    
    public bonusPath = new Subject<any>();
    public bonusPathObserable = this.bonusPath.asObservable();

    // https://jira.safeway.com/browse/ACIP-267108 - Epic [GAMES] - DG Opt-In Enhancements
    public optinEnhancements = false;

    constructor(private _http: HttpClient, private paramService: ParamService) { }

    public authorize = function (userInfo) {
        return (userInfo && typeof userInfo.userType != "undefined" && (String(userInfo.userType).toLowerCase() == null ||
            String(userInfo.userType).toLowerCase() == '' || String(userInfo.userType).toLowerCase() == 'g'
            || String(userInfo.userType).toLowerCase() == 'a')) ? false : true;
    };

    public isAuthenticated(userInfo: any): boolean {
        const currentDate = new Date();
        const expiryDate = userInfo && new Date(Number(userInfo['expireTime']));
        return userInfo.SWY_SHOP_TOKEN !== '' && (expiryDate > currentDate) && this.authorize(userInfo);
    }

    getEnvironment() {
        let environment;
        if (window.location.origin.indexOf('qa1') > 0 || window.location.origin.indexOf('qa2') > 0 || window.location.origin.indexOf('qa3') > 0 || window.location.origin.indexOf('stage') > 0) {
            environment = window.location.host.split('-')[1].split('.')[0];
        } else if (window.location.origin.indexOf('local') > 0) {
            environment = 'qa1';
        } else {
            environment = 'prod';
        }
        return environment;
    }

    getApplicationDomainURL() {
        let domain;
        if (window.location.href.indexOf('local') > 0) {
            domain = 'https://www-qa1.' + this.banner + '.com';
        } else {
            domain = 'https://' + window.location.host;
        }
        return domain;
    }

    parseJwt(jwtToken) {
        const base64Url = jwtToken.split('.')[1];
        const base64 = base64Url.replace('-', '+').replace('_', '/');
        return JSON.parse(window.atob(base64));
    }
    
    getUserClaims(user) {
        const oktaToken = this.parseJwt(user.SWY_SHOP_TOKEN);
        const userClaims = {
            aln: oktaToken['aln'],
            hid: oktaToken['hid'],
            zip: oktaToken['zip'],
            gid: oktaToken['gid'],
            uuid: oktaToken['uuid'],
            exp: oktaToken['exp'],
            firstname: oktaToken['fnm'],
            lastname: oktaToken['lnm']
        };
        return userClaims;
    }

    public redeemToken(redemptionRequest: any, userInfo): any { // should update the format
        const currentEnvironment = this.getEnvironment();
        const url = this.getApplicationDomainURL() + environment[currentEnvironment].redemption;
        

        const body: any = {
            ...redemptionRequest
        }
        let headerObj = environment[currentEnvironment].gamesAPIHeaders.getProgram;
        this.replaceHeaderBanner(headerObj);

        const options =  {
            headers : {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4(),
                'StoreId': userInfo.j4uStoreId,
                'client-name' : 'webui',
                'correlation-id': uuidv4(),
            }
         }
        return this._http.post(url, body, options).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.handleError)
        );
    }

    // I think we are not using this API method
    public deliveryAddressPath(formData: any, userInfo:any): any { // should update the format
        const currentEnvironment = this.getEnvironment();
        const url = this.getApplicationDomainURL() + this.ucaAPIPathWithCustomerId(environment[currentEnvironment].getprofileAddressPath, userInfo);
        const headerObj = environment[currentEnvironment].gamesUCAHeaders.getProfile;
        this.replaceHeaderBanner(headerObj);
       
        // console.warn("div deliveryAddressPath()", headers);
        // sample body 
        /** 
         * {"address1":"23434","address2":"","addressType":{"name":"1"},"city":"Englewood","purposes":[{"name":"Delivery"}],"state":"FL","zipCode":"34223"}
         * 
        */
        const body: any = {
            ...formData
        }

        const httpOptions = {
            headers : {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4(),
                'StoreId': userInfo.j4uStoreId,
                'client-name' : 'webui',
                'correlation-id': uuidv4()
            }
        }

        return this._http.post(url, body, httpOptions).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.handleDeliveryAddress)
        );
        //"The address you entered could not be validated against U.S Postal Service records. Please correct your entry below.";

    }

    public validateZipCode(zipCode: string, userInfo: any): Observable<any> {
        const currentEnvironment = this.getEnvironment();
        const url = this.getApplicationDomainURL() + environment[currentEnvironment].storeResolverZipToCityEndpoint+`?zipcode=${zipCode}`;
        const headerObj = environment[currentEnvironment].gamesAPIHeaders.xAPIstoreResolverHttpOptions;
        this.replaceHeaderBanner(headerObj);
        const httpOptions = {
            headers : {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4(),
                'StoreId': userInfo.j4uStoreId,
                'client-name' : 'webui',
                'correlation-id': uuidv4()
            }
        }

        return this._http.get(url, { headers: httpOptions.headers })
            .pipe(
                map((data: any) => {
                    const city = data?.geo?.address2 || '';
                    const state = data?.geo?.region || '';
                    return { city, state };
                }),
                catchError(this.handleValidateZipCode),
                //catchError((err) => Observable.of({ errorMessage: err }))
            );
    }

    public getCustomerType(userInfo): Observable<any> {

        const currentEnvironment = this.getEnvironment();
        const url = this.getApplicationDomainURL() + this.ucaAPIPathWithCustomerId(environment[currentEnvironment].getprofileAddressPath, userInfo);
        const headerObj = environment[currentEnvironment].gamesUCAHeaders.getProfile;
        this.replaceHeaderBanner(headerObj);
        const options =  {
            headers : {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4(),
                'x-swy-date': new Date()
            }
         }

        
        let parameters: HttpParams = new HttpParams();

        parameters = parameters.append('fl', 'preferences,address,loyalty');
        return this._http.get(url, { headers: options.headers, params: parameters })
            .pipe(map((data: any) => {
                return this.getListOfAddress(data);
            }),
                catchError(this.handleError)
            );
    }

    public getListOfAddress(data: any): any {

        const firstName = data['profile'] &&
        data['profile']['personalInfo'] &&
        data['profile']['personalInfo']['name'] &&
        data['profile']['personalInfo']['name']['firstName'] ? data.profile.personalInfo.name.firstName : '';

        const lastName = data['profile'] &&
        data['profile']['personalInfo'] &&
        data['profile']['personalInfo']['name'] &&
        data['profile']['personalInfo']['name']['lastName'] ? data.profile.personalInfo.name.lastName : ''

        const addresses = data && data["addresses"] && data['addresses'].map((item) => {
            return ({
                firstName: item.name && item.name.firstName ? item.name.firstName : firstName,
                lastName: item.name && item.name.lastName ? item.name.lastName : lastName,
                address: item.address1,
                address2: item['address2'] ? item['address2'] : '',
                state: item.state,
                city: item.city,
                zipCode: item.zipCode,
                addressId: item.addressId
            });
        });
        let customerType = 'C';
        if (data.profile && data.profile.customerType && data.profile.customerType === 'E') {
            customerType = 'E'
        }
        const actualData = {
            firstName: firstName,
            lastName: lastName,
            addresses,
            customerType: customerType,
            phoneNumber: data.hasOwnProperty('profile') &&
                data['profile'].hasOwnProperty('phones') &&
                data.profile.phones
                    .find((e: any) => {
                        return e.purposes.filter((pn: any) => pn.name === 'PRIMARY')
                    }).number || '',
            primaryemail: data.profile &&
                data.profile.emails && data.profile.emails.length &&
                data.profile.emails[0].text ? data.profile.emails[0].text : ''
        };
        return actualData;
    }

    public getProgramCodes(programData): string[] {
        const codes = [];
        for (const property in programData) {
            if ((property == 'userOptedInPrograms' || property == 'storePrograms')) {
                programData[property].forEach((each, index) => {
                    if (each.code) {
                        codes.push(each.code);
                    }
                })
            }
        }
        return codes;
    }

    public mergeProgramData = (programData, gameRewards) => {

        for (const property in programData) {
            if ((property == 'userOptedInPrograms' || property == 'storePrograms')) {
                programData[property].forEach((each) => {
                    gameRewards.programPoints.forEach((program) => {
                        if (each.code === program.programCode) {
                            each.totalGamePoints = program.totalGamePoints ? program.totalGamePoints : 0;
                            each.totalPrizesWon = program.totalPrizesWon ? program.totalPrizesWon : 0;
                            each.sweepstakesEntries = program.sweepstakesEntries ? program.sweepstakesEntries : 0;
                            each.gameplaysUsed = program.gameplaysUsed ? program.gameplaysUsed : 0;
                        }
                    });
                });
            }
        }
        return programData;
    }


    public updateProgramData(programData: any, userInfo:any) {

        for (const property in programData) {
            if ((property == 'userOptedInPrograms' || property == 'storePrograms')) {
                programData[property].forEach((each) => {
                    if (each.hasOwnProperty('code')) {
                        each.totalGamePoints = 0;
                        each.totalPrizesWon = 0;
                        each.sweepstakesEntries = 0;
                        each.gameplaysUsed = 0;
                        each.gameStatus = each.optInStatus ? GAMESTATUS[1] : GAMESTATUS[0];
                        let minAge = each.type === GAMETYPES.DIVISION ? MINAGES.DIVISION : MINAGES.EPISODIC;
                        // convert to date objects
                        each.startDate = new Date(each.startDate.split(' ')[0]);
                        each.endDateString = each.endDate;
                        each.endDate = new Date(each.endDate.split(' ')[0]);
                        each.howItWorks = each.howItWorks || false;
                        
                        if (each.postProgLiveDate) {
                            each.postProgLiveDate = new Date(each.postProgLiveDate.split(' ')[0]);
                        }
                        const today = new Date();
                        if (today > each.endDate) {
                            each.gameStatus = GAMESTATUS[2];  // Game Over
                        }
                        each.faqurl = each['uiAttributes'] && each['uiAttributes']['FAQURL'] ? this.getBannerReplacedURL(each['uiAttributes']['FAQURL'], userInfo) : '';
                        each.rulesurl = each['uiAttributes'] && each['uiAttributes']['RULESURL'] ? this.getBannerReplacedURL(each['uiAttributes']['RULESURL'], userInfo) : '';
                        each.gameurl = each['uiAttributes'] && each['uiAttributes']['GAMEURL'] ? this.getBannerReplacedURL(each['uiAttributes']['GAMEURL'], userInfo) : '';
                        each.tokenLabelSingular = each['uiAttributes'] && each['uiAttributes']['tokenLabelSingular'] ? each['uiAttributes']['tokenLabelSingular'] : 'Game point';
                        each.tokenLabelPlural = each['uiAttributes'] && each['uiAttributes']['tokenLabelPlural'] ? each['uiAttributes']['tokenLabelPlural'] : 'Game points';
                        each.minAge = each['uiAttributes'] && each['uiAttributes']['minAge'] ? parseInt(each['uiAttributes'] && each['uiAttributes']['minAge']) : minAge;
                    }
                });
            }
        }
        if (programData['sweepstakesWinners']) {
            programData['sweepstakesWinners'] = programData['sweepstakesWinners'].filter(item => !item.displayed);
        }
        if( programData.optInEnhancementsEnabled !== undefined ) {
            this.optinEnhancements = programData.optInEnhancementsEnabled;
        }

        return programData;
    }

    public replaceHeaderBanner(header) {
        if (header) {
            if (header['banner']) {
                header['banner'] = header['banner'].replace(/\{banner\}/g, this.banner);
            }
            if (header['x-swy_banner']) {
                header['x-swy_banner'] = header['x-swy_banner'].replace(/\{banner\}/g, this.banner);
            }
        }
    }

    public getPrograms(programCode, userInfo): Observable<any> {
        const currentEnvironment = this.getEnvironment();
        let url = this.getApplicationDomainURL() + environment[currentEnvironment].getPrograms;
        let headerObj = environment[currentEnvironment].gamesAPIHeaders.getProgram;
        this.replaceHeaderBanner(headerObj);

        const options =  {
            headers : {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4(),
                'StoreId': userInfo.j4uStoreId,
                'client-name' : 'webui',
                'correlation-id': uuidv4()
            }
         }



        let parameters: HttpParams = new HttpParams();
        parameters = parameters.append('storeId', userInfo.j4uStoreId);
        if(userTypeParamFlag) {
            parameters = parameters.append('userType', userInfo.userType);
        }
        if (programCode && programCode != '' && programCode != '*') {
            parameters = parameters.append('programCodes', programCode);
        }
        return this._http.get(url, { headers: options.headers, params: parameters })
        .pipe(map((programData: any) => {
            return this.updateProgramData(programData, userInfo);
        }),
            catchError(this.handleError)
        );
    }


    public getProgramPoints(codes: string[], userInfo): Observable<any> {
        // request GET 'http://localhost:9091/gamification/internal/gamepoints?programCodes=ALL'
        const currentEnvironment = this.getEnvironment();
        let programsUrl = this.getApplicationDomainURL() + environment[currentEnvironment].programPoints;
        let headerObj = environment[currentEnvironment].gamesAPIHeaders.getProgram;
        this.replaceHeaderBanner(headerObj);

        const options =  {
            headers : {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4(),
                'StoreId': userInfo.j4uStoreId,
                'client-name' : 'webui',
                'correlation-id': uuidv4()
            }
         }


        let parameters: HttpParams = new HttpParams();
        parameters = parameters.append('programCodes', codes.toString());

        return this._http.get(programsUrl, { headers: options.headers, params: parameters })
            .pipe(map((programPoints: any) => {
                return programPoints;
            }), catchError(this.handleError));


    }

    public getPrizes(programCode: string, userInfo: any): Observable<Prizes> {

        const currentEnvironment = this.getEnvironment();
        let url = this.getApplicationDomainURL() + environment[currentEnvironment].prizes;
        let headerObj = environment[currentEnvironment].gamesAPIHeaders.getProgram;
        this.replaceHeaderBanner(headerObj);

        const options =  {
            headers : {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4(),
                'StoreId': userInfo.j4uStoreId,
                'client-name' : 'webui',
                'correlation-id': uuidv4(),
            }
         }

        let parameters: HttpParams = new HttpParams();
        if (programCode && programCode != '' && programCode != '*') {
            parameters = parameters.append('programCode', programCode);
        }
        parameters = parameters.append('storeId', userInfo.j4uStoreId);
        if(userTypeParamFlag) {
            parameters = parameters.append('userType', userInfo.userType);
        }
        return this._http.get(url, { headers: options.headers, params: parameters })
        .pipe(map((prizes: Prizes) => {
            return prizes;
        }), catchError(this.handleError));
    }

    public getPrizeDetails(prizeId: string, prizeType: string, programCode: string, userInfo): Observable<PrizeDetail> {
        const currentEnvironment = this.getEnvironment();
        const prizeDetailUrl = this.getApplicationDomainURL() + environment[currentEnvironment].prizes + '/' + prizeId;
        let headerObj = environment[currentEnvironment].gamesAPIHeaders.getProgram;
        this.replaceHeaderBanner(headerObj);

        const options =  {
            headers : {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4(),
                'StoreId': userInfo.j4uStoreId,
                'client-name' : 'webui',
                'correlation-id': uuidv4(),
            }
         }

        let parameters: HttpParams = new HttpParams();
        parameters = parameters.append('prizeType', prizeType)
        parameters = parameters.append('programCode', programCode);
        parameters = parameters.append('storeId', userInfo.j4uStoreId);

        return this._http.get(prizeDetailUrl, { headers: options.headers, params: parameters })
            .pipe(map((prizeDetails) => {
                return prizeDetails['prize'];
            }), catchError(this.handleError));

    }

    public getMyPrizes(programCode: string, userInfo: any): Observable<any> {
        const currentEnvironment = this.getEnvironment();
        let prizeDetailUrl = this.getApplicationDomainURL() + environment[currentEnvironment].userPrizeTransactions.replace('{uuid}',  userInfo.UUID);
        let headerObj = environment[currentEnvironment].gamesAPIHeaders.getProgram;
        this.replaceHeaderBanner(headerObj);
        const options =  {
            headers : {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4(),
                'client-name' : 'webui',
                'correlation-id': uuidv4(),
                'user-time-zone':  Intl.DateTimeFormat().resolvedOptions().timeZone
            }
         }
        let params: HttpParams = new HttpParams();
        params = params.append('programCode', programCode);

        const httpOptions = {
            headers: options.headers,
            params
        }
        return this._http.get(prizeDetailUrl, httpOptions)
            .pipe(map((myPrizes: MyPrize[]) => {
                return myPrizes;
            }), catchError(this.handleError));
    }

    public getTokenActivity(gameCode: string, forceReload: boolean, userInfo:any): Observable<any> {

        let params: any;
        let body: any;
        let headers : any;
        let rewardsTransactionEndpoint: string;

        const currentEnvironment = this.getEnvironment();
        rewardsTransactionEndpoint = this.getApplicationDomainURL() + environment[currentEnvironment].ocrpRewardsTransactionEndpoint;
        headers = environment[currentEnvironment].gamesAPIHeaders.xAPIOcrpRewardsHttpOptionsV2;
        params = {
            numberOfDays: 180,
            programs: gameCode
        }
        
        headers["X-ABS-Client-ID"] = "OCGP";
        headers['x-swy-correlation-id'] = uuidv4();
        headers['Authorization'] = `Bearer ${userInfo.SWY_SHOP_TOKEN}`;


        if (forceReload) {
            let dateStamp = new Date();
            params.rand = dateStamp.valueOf();
        }
        let httpOptions = {
            headers: headers,
            params: params
        };

        const userClaims = this.getUserClaims(userInfo);
        return this._http.get(rewardsTransactionEndpoint + "/" + userClaims.hid, httpOptions).pipe(map(data => {
            return data;
        }));
    }

    public getGameActivity(gameCode: string, userInfo:any): Observable<any> {

        const currentEnvironment = this.getEnvironment();
        let url = this.getApplicationDomainURL() + environment[currentEnvironment].userGameActivity.replace('{uuid}',  userInfo.UUID);
        let params: any; 
        params = {
            numberOfDays: 180,
            programCodes: gameCode
        }

        let headers = environment[currentEnvironment].gamesAPIHeaders.getProgram;
        headers["client-name"] = "webui";
        headers["user-time-zone"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
        headers['entry'] = 'web',
        headers['x-swy-correlation-id'] = uuidv4();
        headers['Authorization'] = `Bearer ${userInfo.SWY_SHOP_TOKEN}`;
        headers['correlation-id'] = uuidv4();
        
        let httpOptions = {
            headers: headers,
            params: params
        };

        return this._http.get(url, httpOptions).pipe(map(data => {
            return data;
        }));
    }

    public getSweepstakeWinner(programCode: string, userInfo) {
        
        const currentEnvironment = this.getEnvironment();
        let url = this.getApplicationDomainURL() + environment[currentEnvironment].sweepstakeWinner;
        let headerObj = environment[currentEnvironment].gamesAPIHeaders.getProgram;
        this.replaceHeaderBanner(headerObj);
        const options =  {
            headers : {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4(),
                'StoreId':  userInfo.j4uStoreId,
                'client-name' : 'webui',
                'correlation-id': uuidv4()
            }
         }

        let params: HttpParams = new HttpParams();
        params = params.append('programCode', programCode);

        const httpOptions = {
            headers: options.headers,
            params
        }

        return this._http.get(url, httpOptions).pipe(
            map((data: any) => {
                data = data.filter(item => item.displayed == false);
                return data;
            }),
            catchError(this.handleError)
        );
    }

    public acknowledgeSweepstakesWin(prizeId: string, programCode: string, userInfo:any) {
        const currentEnvironment = this.getEnvironment();
        const url = this.getApplicationDomainURL() + environment[currentEnvironment].sweepstakesWinDisplay;
        let headerObj = environment[currentEnvironment].gamesAPIHeaders.getProgram;

        const body: any = {
            displayed: true,
            prizeId: prizeId,
            programCode: programCode
        }

        const httpOptions =  {
            headers : {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4(),
                'correlation-id': uuidv4(),
                'client-name': 'webui'
            }
         }

        return this._http.post(url, body, httpOptions).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.handleError)
        );
    }

    public getPostGameDetails(programCode: string, userInfo: any) {
        
        const currentEnvironment = this.getEnvironment();
        const url = this.getApplicationDomainURL() + environment[currentEnvironment].postGameDetails;
        const headerObj = environment[currentEnvironment].gamesAPIHeaders.getProgram;

        let params: HttpParams = new HttpParams();
        params = params.append('programCode', programCode);

        const httpOptions =  {
            headers : {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'correlation-id': uuidv4(),
                'client-name':'webui'
            },
            params
        }

        return this._http.get(url, httpOptions).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.handleError)
        );

    }

    public trapFocus(modalId: any) {

        let modal = document.querySelector(modalId); // select the modal by it's id

        let focusableElements = modal.querySelectorAll("a[href]:not([tabindex='-1']):not(.inactive),area[href]:not([tabindex='-1']),input:not([disabled]):not([tabindex='-1']),select:not([disabled]):not([tabindex='-1']),textarea:not([disabled]):not([tabindex='-1']),button:not([disabled]):not([tabindex='-1']),iframe:not([tabindex='-1']),[tabindex]:not([tabindex='-1'])");
        let firstFocusableElement = focusableElements[0];
        let lastFocusableElement = focusableElements[focusableElements.length - 1];

        if (modal) {
            firstFocusableElement.focus();
            modal.addEventListener('keydown', function (e) {
                let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

                if (!isTabPressed) {
                    return;
                }

                if (e.shiftKey) {
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement.focus();
                        e.preventDefault();
                    }
                } else {
                    if (document.activeElement === lastFocusableElement) {
                        firstFocusableElement.focus();
                        e.preventDefault();
                    }
                }
            });
        }
    }

    public getBannerReplacedURL(url: string = '', userInfo:any): string {
        return url.replace(/{banner}/g, userInfo.banner);
    }

    public ucaAPIPathWithCustomerId = function (path, userInfo:any) {
        var customerId = userInfo.customerId ? userInfo.customerId : '1';
        return path.replace('{customerId}', customerId);
    };

    public getCustomerProfileDetails(gameName, userInfo): Observable<any> {
        const currentEnvironment = this.getEnvironment();
        const url = this.getApplicationDomainURL() + this.ucaAPIPathWithCustomerId(environment[currentEnvironment].getprofileAddressPath, userInfo);
        const headerObj = environment[currentEnvironment].gamesUCAHeaders.getProfile;
        this.replaceHeaderBanner(headerObj);
        const options =  {
            headers : {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'x-swy-correlation-id': uuidv4(),
                'x-swy-date': new Date()
            }
         }
        let params: HttpParams = new HttpParams();
        params = params.append('programCode', gameName);

        let parameters: HttpParams = new HttpParams();

        parameters = parameters.append('fl', 'HOUSEHOLD');
        parameters = parameters.append('hhSubs', 'true');
        return this._http.get(url, { headers: options.headers, params: parameters })
            .pipe(map((data: any) => {
                return this.processUCAProfile(data, gameName);
            }),
                catchError(this.handleError)
            );
    }

    public shortDate(dateString: string, splitter: string = "/", shortYear = false) : string {
        // Parse the date string to a Date object
        const datePart = dateString.split('T')[0];
        const [year, month, day] = datePart.split('-');
        return [month, day, (shortYear?year.slice(-2):year)].join(splitter);
    }

    private processUCAProfile(data, gameName): ProfileType {
        let result: ProfileType = { firstName: '', lastName: '', email: '', optin: false, subscriptionValue: '', effectiveTimePeriods: {}, profileErrorMsg: '', phones:[] };
        if (data) {
            const gameSubscription = data.householdAccount && data.householdAccount.householdProgramSubscriptions && data.householdAccount.householdProgramSubscriptions.filter((eachSub) => {
                return (eachSub.status === 'ACTIVE' && eachSub.name === gameName);
            });
            if (gameSubscription && gameSubscription.length === 1) {
                result.subscriptionValue = gameSubscription[0].value || '';
                result.effectiveTimePeriods = gameSubscription[0].effectiveTimePeriods || {};
                result.optin = (gameSubscription[0].status === 'ACTIVE' && gameSubscription[0].name === gameName);
            } 
            if (data.profile && data.profile.personalInfo && data.profile.personalInfo.name) {
                result.firstName = data.profile.personalInfo.name.firstName || '';
                result.lastName = data.profile.personalInfo.name.lastName || '';
            } 
            result.email = data.profile && data.profile.emails && data.profile.emails.length && data.profile.emails[0].text ? data.profile.emails[0].text : '';
            result.profileErrorMsg = (data.errors && data.errors.length && data.errors[0].message) || '';
            result.phones = data.profile.phones;
        }
        return result;
    }
    
    public saveOptinWithEarnGamePlay(data: OptInRequestModel, userInfo): Observable<any> {
                
        const requestBody: OptInRequestModel = data;
        
        // console.warn(httpOptions, requestBody, 'headers headers');

        const currentEnvironment = this.getEnvironment();
        const url = this.getApplicationDomainURL() + environment[currentEnvironment].optin;
        const headerObj = environment[currentEnvironment].gamesAPIHeaders.getProgram;

        const httpOptions =  {
            headers : {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'correlation-id': uuidv4(),
                'client-name':'webui'
            }
         }

        return this._http
            .post<any>(url, requestBody, httpOptions)
            .pipe(
                map((data: any) => {
                    return data;
                }),
                catchError(this.handleError)
            );
    }

    public getGamesConfigFlags(): Observable<any> {
        const domain = this.getApplicationDomainURL();
        let url = domain + '/content/dam/data/games/gamesConfig.json' + '?rand=' + Math.random();
        
        return this._http.get(url).pipe(
            map((data: any) => {
                return data;
            }),
            catchError(this.handleError)
        );
    }

    public handleHowItWorks(userInfo, programCode): Observable<any> {
        const currentEnvironment = this.getEnvironment();
        const url = this.getApplicationDomainURL() + environment[currentEnvironment].howItWorks;
        const headerObj = environment[currentEnvironment].gamesAPIHeaders.getProgram;

        let params: HttpParams = new HttpParams();
        params = params.append('programCode', programCode);

        const httpOptions =  {
            headers : {
                ...headerObj,
                'Authorization': `Bearer ${userInfo.SWY_SHOP_TOKEN}`,
                'correlation-id': uuidv4(),
                'client-name':'OCGP'
            },
            params
        }
        return this._http.post(url, {}, httpOptions).pipe(
            map((data: any) => {
                return data;
            }),
        catchError(this.handleError));
    }

    // --------------------------------------------------------------------------
    /**
     * Error Handling for Methods. Returns an error when the call is not passed.
     */
    // --------------------------------------------------------------------------
    private handleError(errorResponse: HttpErrorResponse) {
        let errMsg = 'Apologies, our site is currently experiencing technical difficulties, please try again later.';
        if (!(errorResponse.error instanceof ErrorEvent) && errorResponse.error) {
            // console.error(`status: ${errorResponse.status}, ${errorResponse.statusText}`);
            switch (errorResponse.status) {
                case 401:/** Invalid Auth */
                    errMsg = errorResponse.error['message'] ? errorResponse.error.message : 'Invalid authorization';
                    break;
                case 403:/** Access Denied */
                    errMsg = errorResponse.error['message'] ? errorResponse.error.message : errMsg;
                    break;
                case 400: /* Required/Invalid body Value OR Dependent API - Business Error*/
                    errMsg = errorResponse.error['errors'] && errorResponse.error.errors.length ? errorResponse.error.errors[0].message : errorResponse.error['serviceErrors'] && errorResponse.error.serviceErrors.length ? errorResponse.error.serviceErrors[0].message : errMsg;
                    break;
                case 503:/** Dependent API unavailable */
                    errMsg = errorResponse.error['serviceErrors'] && errorResponse.error.serviceErrors.length ? errorResponse.error.serviceErrors[0].message : errMsg;
                    break;
                case 500:/** Dependent API - System Error */
                    errMsg = errorResponse.error['serviceErrors'] && errorResponse.error.serviceErrors.length ? errorResponse.error.serviceErrors[0].message : errMsg;
                    break;
                // case 504: /** Gate way Timeout */
                //     errMsg = errorResponse.error['serviceErrors'] && errorResponse.error.serviceErrors.length ? errorResponse.error.serviceErrors[0].message : errMsg;
                //     break;
                default:
                    errMsg = 'Apologies, our site is currently experiencing technical difficulties, please try again later.';
                    break;
            }
            return throwError(errMsg);
        }
        return throwError(errMsg);
    }

    private handleValidateZipCode(errorResponse: HttpErrorResponse) {
        if (!(errorResponse.error instanceof ErrorEvent) && errorResponse.error) {
            // console.error(`status: ${errorResponse.status}, ${errorResponse.statusText}`);
            let errMsg = '';
            switch (errorResponse.status) {
                case 404:/** Invalid zipcode passed in the request parameter */
                    errMsg = errorResponse.error['geo'] && errorResponse.error.geo['errors'] && errorResponse.error.geo['errors'].length ? errorResponse.error.geo['errors'][0].message : errMsg;
                    break;
                case 504: /** Gate way Timeout */
                    errMsg = `Sorry, we're having technical difficulties, please check back later.`;
                    break;
                case 406:
                    errMsg = `Not Acceptable`;
                    break;
                default:
                    errMsg = 'Apologies, our site is currently experiencing technical difficulties, please try again later.';
                    break;
            }
            return throwError(errMsg);
        }
    }

    private handleDeliveryAddress(errorResponse: HttpErrorResponse) {
        if (!(errorResponse.error instanceof ErrorEvent) && errorResponse.error) {
            // console.error(`status: ${errorResponse.status}, ${errorResponse.statusText}`);
            let errMsg = '';
            switch (errorResponse.status) {
                case 404:/** Invalid zipcode passed in the request parameter */
                    errMsg = errorResponse.error['errors'] && errorResponse.error['errors'][0] && errorResponse.error['errors'][0]['message'] ? errorResponse.error['errors'][0]['message'] : `Back-end error`;
                    break;
                case 504: /** Gate way Timeout */
                    errMsg = errorResponse.error['errors'] && errorResponse.error['errors'][0] && errorResponse.error['errors'][0]['message'] ? errorResponse.error['errors'][0]['message'] : `Gate-way error`;
                    break;
                case 406:
                    errMsg = errorResponse.error['errors'] && errorResponse.error['errors'][0] && errorResponse.error['errors'][0]['message'] ? errorResponse.error['errors'][0]['message'] : `Not acceptable`;
                    break;
                case 400: // Invalid customer UUID - localhost, QA1 - Delivery Store not found.
                    errMsg = errorResponse.error['errors'] && errorResponse.error['errors'][0] && errorResponse.error['errors'][0]['message'] ? errorResponse.error['errors'][0]['message'] : `Bad Request`;
                    break;
                default:
                    errMsg = 'Apologies, our site is currently experiencing technical difficulties, please try again later.';
                    break;
            }
            return throwError(errMsg);
        }
    }
}
